// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"414":"d089db15","874":"bea8a57a"}[chunkId] + ".css";
};